import { isBase64 } from "validator";

// Not comprehensive, just checks to see if the text looks like it could be a PEM-encoded certificate.
export function likelyPemEncodedCertificate(str: string): boolean {
  return /^-+BEGIN CERTIFICATE-+\n[A-Za-z0-9+/\n]+={0,2}\n-+END CERTIFICATE-+$/.test(
    str,
  );
}

export function likelyBase64EncodedPEMBlock(str: string): boolean {
  // base64 prefix "-----B" (8 sextets/6 octets)
  return str.startsWith("LS0tLS1C") && isBase64(str);
}
